<val-boite-dialogue-generique #boiteDialogueLog
                              class="val-boite-dialogue-log"
                              [titre]="titre"
                              annulerVisible="false"
                              (validerClick)="Fermer()">
  <div bandeau
       class="val-boite-dialogue-log-bandeau">
    <val-simple-libelle [libelle]="bandeau">
    </val-simple-libelle>
  </div>
  <div contenu
       class="val-boite-dialogue-log-contenu">
    <val-simple-tree-view [items]="items"
                          [itemsOuverts]="itemsOuverts">
    </val-simple-tree-view>
  </div>
  <div piedPage
       class="val-boite-dialogue-log-pied-page val-flex-conteneur">
    <val-simple-image class="val-boite-dialogue-log-pied-page-erreur-icone"
                      [width]="16"
                      [height]="16"
                      src="assets/iconeRg0.png">
    </val-simple-image>
    <val-simple-libelle class="val-boite-dialogue-log-pied-page-erreur-libelle"
                        [libelle]="'achat.logs-transfert.erreurs' | transloco">
    </val-simple-libelle>
    <val-simple-libelle class="val-boite-dialogue-log-pied-page-erreur-valeur"
                        [libelle]="nombreErreur.toString()">
    </val-simple-libelle>
    <val-simple-image class="val-boite-dialogue-log-pied-page-succes-icone"
                      [width]="16"
                      [height]="16"
                      src="assets/iconeRg3.png">
    </val-simple-image>
    <val-simple-libelle class="val-boite-dialogue-log-pied-page-succes-libelle"
                        [libelle]="'achat.logs-transfert.succes' | transloco">
    </val-simple-libelle>
    <val-simple-libelle class="val-boite-dialogue-log-pied-page-succes-valeur"
                        [libelle]="nombreSucces.toString()">
    </val-simple-libelle>
  </div>
</val-boite-dialogue-generique>
